/**
 * Created by cbikar on 2/2/2016.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/coBrowseConfigEdit.tmpl");
    var Button = require("ui/button/Button");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Checkbox = require("ui/checkbox/Checkbox");
    var ColorPicker = require("ui/color-picker/ColorPicker");
    var TagsContainer = require("ui/tags-container/TagsContainer");
    var Bubble = require("ui/bubble/Bubble");
    var Settings = require("codeTables/settings.json");


    var P_INTERACTIVE = "p-interactive";
    var P_VIEW = "p-view";
    var ENABLED_VALUE = "true";
    var DISABLED_VALUE = "false";

    var CoBrowseConfigEditView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        CoBrowseConfigEditView = Marionette.CompositeView.extend({
            template: template,
            className: "default-cobrowse-config-edit-view anchor",
            ui: {
                saveButton: ".save-button",
                cancelButton: ".cancel-button",
                cobrowseEnabledToggle: ".cobrowse-enabled-toggle",
                viewOnlyCheckBox: ".view-only-checkbox",
                sharedCheckBox: ".shared-checkbox",
                borderColor: ".border-color",
                highlightColor: ".highlight-color",
                resizeAgentToggle: ".cobrowse-resize-toggle",
                resizeAgentIcon: ".resize-agent-icon",
                protectFields: ".protectFields",
                protectFieldsIcon: ".protect-fields-icon"
            },
            uiComponents: {
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                cobrowseEnabledToggle: {
                    type: ToggleButton,
                    options: {
                        transition: ToggleButton.TRANSITION.FAST,
                        permutation: ToggleButton.PERMUTATION.NIGHT_THEME,
                        container: "view.ui.cobrowseEnabledToggle",
                        checked: "view._getCoBrowseEnabled",
                        tooltip: {
                            active: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.enabled"),
                            inactive: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.disabled")
                        },
                        commitStateChange: false
                    },
                    events: {
                        "toggleButton:change": "_onCoBrowseEnabledChanged"
                    }
                },
                viewOnlyCheckBox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.viewOnlyCheckBox",
                        permutation: Checkbox.PERMUTATION.NIGHT,
                        label: LE.translator.translate("LEPersonalization.webAgent.cobrowse.edit.cbMode.viewOnly.label"),
                        checked: "view._hasViewOnlyPermission"
                    }
                },
                sharedCheckBox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.sharedCheckBox",
                        permutation: Checkbox.PERMUTATION.NIGHT,
                        label: LE.translator.translate("LEPersonalization.webAgent.cobrowse.edit.cbMode.shared.label"),
                        checked: "view._hasSharedPermission"
                    }
                },
                resizeAgentToggle: {
                    type: ToggleButton,
                    options: {
                        transition: ToggleButton.TRANSITION.FAST,
                        container: "view.ui.resizeAgentToggle",
                        checked: "view._getAgentResizeEnabled",
                        permutation: ToggleButton.PERMUTATION.NIGHT_THEME,
                        tooltip: {
                            active: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.enabled"),
                            inactive: LE.translator.translate("LECampaigns.engagementDetailsView.activation.button.tooltip.disabled")
                        },
                        commitStateChange: false
                    },
                    events: {
                        "toggleButton:change": "_onAgentResizeChanged"
                    }
                },
                protectFields: {
                    type: TagsContainer,
                    options: {
                        container: "view.ui.protectFields",
                        placeholder: "CSS Selector",
                        items: "view._getProtectedFields",
                        tagMaxWidth: "395px",
                        maxShownLines: 2
                    },
                    events: {
                        "input:create": "_onProtectedFieldAdded",
                        "tag:remove": "_onProtectedFieldRemoved"
                    }
                }
            },
            events: {
                "mouseenter @ui.resizeAgentIcon": "_showResizeAgentBubble",
                "mouseleave @ui.resizeAgentIcon": "_closeResizeAgentBubble",
                "mouseenter @ui.protectFieldsIcon": "_showProtectFieldsBubble",
                "mouseleave @ui.protectFieldsIcon": "_closeProtectFieldsBubble"

            },

            initialize: function (options) {
                this.settingsCollection = options.settingsCollection;

                var agentCanChooseProfile = this._decodeValue(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE).getValue()) === ENABLED_VALUE;
                var agentProfile = this._decodeValue(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_AGENTPROFILE).getValue());

                this.isSharedMode = agentCanChooseProfile || agentProfile === P_INTERACTIVE;
                this.isViewOnlyMode = agentCanChooseProfile || agentProfile !== P_INTERACTIVE;

                this.isCoBrowseEnabled = (this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_DISABLED).getValue() === DISABLED_VALUE);
                this.borderColor = this._decodeValue(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_BORDERCOLOR).getValue());
                this.highlightColor = this._decodeValue(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_HIGHLIGHTCOLOR).getValue());

                this.resizeAgentScreen = this._decodeValue(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_AGENTRESIZE).getValue()) === ENABLED_VALUE;
                this.maskedFields = this._decodeArray(this.settingsCollection.get(Settings.SETTING_ID.COBROWSE_MASKEDFIELDS).getValue());
            },

            onRender: function () {
                this.renderBorderColorPicker();
                this.renderHighlightColorPicker();
            },

            renderBorderColorPicker: function () {
                this.borderColorPicker = new ColorPicker({
                    el: this.ui.borderColor,
                    testCollision: true,
                    collisionWithinSelector: ".personalization-bubble",
                    permutation: ColorPicker.PERMUTATION.C
                });
                this.borderColorPicker.render();
                this.borderColorPicker.setColor(this.borderColor);
            },

            renderHighlightColorPicker: function () {
                this.highlightColorPicker = new ColorPicker({
                    el: this.ui.highlightColor,
                    testCollision: true,
                    collisionWithinSelector: ".personalization-bubble",
                    permutation: ColorPicker.PERMUTATION.C
                });
                this.highlightColorPicker.render();
                this.highlightColorPicker.setColor(this.highlightColor);
            },

            _getCoBrowseEnabled: function () {
                return this.isCoBrowseEnabled;
            },

            _hasSharedPermission: function () {
                return this.isSharedMode;
            },

            _hasViewOnlyPermission: function () {
                return this.isViewOnlyMode;
            },

            _getProtectedFields: function () {
                return _.map(this.maskedFields, function (item) {
                    return {
                        id: item,
                        value: item
                    };
                });
            },

            _getAgentResizeEnabled: function () {
                return this.resizeAgentScreen;
            },

            _onCoBrowseEnabledChanged: function (componentId, eventName, value) {
                this.uiComponents.cobrowseEnabledToggle.toggle();
                this.isCoBrowseEnabled = value;
            },

            _onAgentResizeChanged: function (componentId, eventName, value) {
                this.uiComponents.resizeAgentToggle.toggle();
                this.resizeAgentScreen = value;
            },

            _onProtectedFieldAdded: function (componentId, eventName, obj) {
                var value = $.trim(obj.value);
                var container = this.uiComponents.protectFields;

                if (value.length !== 0) { // make sure keyword is not empty
                    var item = {
                        "id": value,
                        "value": value
                    };

                    container.addItem(item);
                    container.clearInputValue();
                    container.setFocus();

                    this._updateProtectedFieldsItems();
                }
            },

            _updateProtectedFieldsItems: function () {
                var container = this.uiComponents.protectFields;
                var fields = container.getItems();
                this.maskedFields = this._getValuesAsArray(fields);
            },

            _onProtectedFieldRemoved: function () {
                this._updateProtectedFieldsItems();
            },

            _showProtectFieldsBubble: function () {
                this._closeProtectFieldsBubble();
                this.uiComponents.host$.createAndRender("protectFieldsBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.protectFieldsIcon,
                        text: LE.translator.translate("LEPersonalization.webAgent.cobrowse.edit.cbFieldMasking.info"),
                        position: Bubble.POSITION.BOTTOM,
                        showCloseButton: false,
                        permutation: Bubble.PERMUTATION.F
                    }
                });
            },

            _closeProtectFieldsBubble: function () {
                if (this.uiComponents.protectFieldsBubble) {
                    this.uiComponents.protectFieldsBubble.close();
                }
            },

            _showResizeAgentBubble: function () {
                this._closeResizeAgentBubble();
                this.uiComponents.host$.createAndRender("resizeAgentBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.resizeAgentIcon,
                        text: LE.translator.translate("LEPersonalization.webAgent.cobrowse.edit.cbResize.info"),
                        position: Bubble.POSITION.BOTTOM,
                        showCloseButton: false,
                        permutation: Bubble.PERMUTATION.F
                    }
                });
            },

            _closeResizeAgentBubble: function () {
                if (this.uiComponents.resizeAgentBubble) {
                    this.uiComponents.resizeAgentBubble.close();
                }
            },

            _onSave: function () {
                if (this._validateSettings()) {
                    LEPersonalization.logger.debug("saving site settings", "CoBrowseConfigEditView:_save.");

                    var agentCanChooseProfile = this.uiComponents.viewOnlyCheckBox.isChecked() && this.uiComponents.sharedCheckBox.isChecked();
                    var agentProfile = this.uiComponents.sharedCheckBox.isChecked() ? P_INTERACTIVE : P_VIEW;

                    var options = {};
                    options[Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE] = this._encodeValue(agentCanChooseProfile.toString());
                    options[Settings.SETTING_ID.COBROWSE_AGENTPROFILE] = this._encodeValue(agentProfile);
                    options[Settings.SETTING_ID.COBROWSE_DISABLED] = (!this.isCoBrowseEnabled).toString();
                    options[Settings.SETTING_ID.COBROWSE_AGENTRESIZE] = this._encodeValue(this.resizeAgentScreen.toString());
                    options[Settings.SETTING_ID.COBROWSE_BORDERCOLOR] = this._encodeValue(this.borderColorPicker.getColor());
                    options[Settings.SETTING_ID.COBROWSE_HIGHLIGHTCOLOR] = this._encodeValue(this.highlightColorPicker.getColor());
                    options[Settings.SETTING_ID.COBROWSE_MASKEDFIELDS] = this._encodeArray(this.maskedFields);

                    this.trigger("coBrowseConfig:save", options);
                } else {
                    this._onValidationFailed();
                }
            },

            _onCancel: function () {
                this.trigger("coBrowseConfig:cancel");
            },

            _validateSettings: function () {
                // validate if either view only or shared mode is set when cobrowse is enabled
                return !(this.isCoBrowseEnabled && !this.uiComponents.viewOnlyCheckBox.isChecked() && !this.uiComponents.sharedCheckBox.isChecked());
            },

            _onValidationFailed: function () {
                var errorMsg = LE.translator.translate("LEPersonalization.webAgent.cobrowse.edit.errors.modeValidation");
                this.uiComponents.viewOnlyCheckBox.setError(true, errorMsg);
                this.uiComponents.sharedCheckBox.setError(true, errorMsg);
            },

            _getValuesAsArray: function (fields) {
                var array = [];
                if (!_.isEmpty(fields)) {
                    for (var item in fields) {
                        if (fields.hasOwnProperty(item)) {
                            array.push(fields[item].value);
                        }
                    }
                }
                return array;
            },

            _decodeValue: function (val) {
                return atob(val);
            },

            _decodeArray: function (array) {
                return _.map(array, function (item) {
                    return atob(item);
                });
            },

            _encodeValue: function (val) {
                return btoa(val);
            },

            _encodeArray: function (array) {
                return _.map(array, function (item) {
                    return btoa(item);
                });
            }

        });
    });

    return CoBrowseConfigEditView;

});
